import React from "react";
import { Deals, MainLayout } from "containers";

export default function App() {
  return (
    <MainLayout backgroundColor="rgb(234, 237, 237)">
      <Deals />
    </MainLayout>
  );
}
